import { render } from "./ColletingReadings.vue?vue&type=template&id=78aad39c&scoped=true"
import script from "./ColletingReadings.vue?vue&type=script&lang=js"
export * from "./ColletingReadings.vue?vue&type=script&lang=js"

import "./ColletingReadings.vue?vue&type=style&index=0&id=78aad39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aad39c"]])

export default __exports__